import { useMemo } from 'react'
import { Outlet } from 'react-router-dom'

import { observer } from 'mobx-react'

import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import permissionGroups from 'modules/permissions/store/collections/permissionGroups'
import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

export interface PermissionGroupContainerProps {
  permissionGroup: PermissionGroup
}

const PermissionGroupContainer = () => {
  const { id } = useStrictParams<'id'>()
  const permissionGroup = useMemo(() => permissionGroups.get(String(id)), [id])

  if (!permissionGroup) return null

  return <Outlet context={{ permissionGroup }} />
}

export default observer(PermissionGroupContainer)
